import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Alert,
  TextField,
  Button,
  Grid,
} from '@mui/material';
import Users from '../../collections/users';
import { useNavigate } from 'react-router-dom';

const InactiveUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [days, setDays] = useState(3);
  const navigate = useNavigate();

  const fetchInactiveUsers = async () => {
    setLoading(true);
    setError(null);
    try {
      const usersCollection = new Users();
      await usersCollection.fetchInactive(days);
      setUsers(usersCollection.items);
    } catch (err) {
      setError('Tải danh sách người dùng không hoạt động thất bại.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInactiveUsers();
  }, [days]);

  const handleSearch = () => {
    fetchInactiveUsers();
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" gutterBottom>
        Người dùng không hoạt động
      </Typography>

      <Paper sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={4}>
            <TextField
              label="Số ngày không hoạt động"
              type="number"
              fullWidth
              value={days}
              onChange={(e) => setDays(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button
              variant="contained"
              onClick={handleSearch}
              disabled={loading}
            >
              Tìm kiếm
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {loading && <CircularProgress />}
      {error && <Alert severity="error">{error}</Alert>}

      {!loading && !error && (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="inactive users table">
            <TableHead>
              <TableRow>
                <TableCell>Tên</TableCell>
                <TableCell>Số điện thoại</TableCell>
                <TableCell>Ngày đặt hàng gần nhất</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((user) => (
                <TableRow
                  key={user.id}
                  sx={{
                    '&:last-child td, &:last-child th': { border: 0 },
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                  }}
                  onClick={() => navigate(`/customers/${user.id}`)}
                >
                  <TableCell component="th" scope="row">
                    {user.name}
                  </TableCell>
                  <TableCell>{user.phone_number}</TableCell>
                  <TableCell>
                    {user.last_order_date
                      ? new Date(user.last_order_date).toLocaleDateString('vi-VN')
                      : '-'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Container>
  );
};

export default InactiveUsers; 